<template>
    <v-dialog v-model="modal" width="900">
        <v-card>
            <template v-for="offer in offers" :key="offer.offerKey">
                <tour-offer-activity-entry :offer="offer" :offer-key="offerKey" :entry-name="entry.entryName">
                    <template v-slot:price="{offer}">
                        <tour-offer-delta-button
                            v-if="showPriceDuringSearch"
                            :offer="offer"
                            :offer-key="offerKey"
                            :entry-name="entry.entryName"
                        />
                    </template>
                </tour-offer-activity-entry>
            </template>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Vue, Component, Prop, Setup} from 'vue-facing-decorator'
    import {EventBus, SHOW_TOUR_ACTIVITY_INFO} from '@/utils/event-bus'
    import TourOfferDeltaButton from '@/components/tours/search/TourOfferDeltaButton.vue'
    import TourOfferActivityEntry from '@/components/tours/search/offers/TourOfferActivityEntry.vue'

    @Component({
        components: {
            TourOfferDeltaButton,
            TourOfferActivityEntry,
        },
    })
    export class TourActivitiesInfoModal extends Vue {
        @Prop({required: true}) searchRequest
        @Setup(() => useBookingPriceButton().showPriceDuringSearch) showPriceDuringSearch

        modal = false
        entry = {}
        offerKey = null

        mounted() {
            EventBus.$on(SHOW_TOUR_ACTIVITY_INFO, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_TOUR_ACTIVITY_INFO, this.showModal)
        }

        async showModal({entry, offerKey}) {
            this.entry = entry
            this.offerKey = offerKey
            this.modal = true
        }

        get offers() {
            return this.entry.offers ? this.entry.offers[0].offers : []
        }
    }

    export default TourActivitiesInfoModal
</script>
